var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBxInPerson(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "aa3d1dab-2013-4ae0-ad6d-bc78fbb8082c",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "ab5033b7-5f5c-4a62-ae04-fb64f904e6fa",
    "data-name": "Path 35",
    d: "M10.548,6.414A2.838,2.838,0,1,1,7.71,3.576a2.838,2.838,0,0,1,2.838,2.838",
    style: {
      fill: "#0cba00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "f2eed87a-9a28-4a05-a467-b7d649513054",
    "data-name": "Path 36",
    d: "M15.542,7.363a2.219,2.219,0,1,1-2.253-2.185h.034a2.2,2.2,0,0,1,2.218,2.181v0",
    style: {
      fill: "#0cba00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a25abd71-2be5-433d-a9e2-60da9c6df185",
    "data-name": "Path 37",
    d: "M14.293,10.279H12.352a2.743,2.743,0,0,0-1.482.438,3.424,3.424,0,0,1,1.568,2.862v.343h4.583v-.956a2.716,2.716,0,0,0-2.728-2.687",
    style: {
      fill: "#0cba00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "b40fbb5d-25d3-474b-96f5-7f9a55695d60",
    "data-name": "Path 38",
    d: "M12.439,15.314V13.577a3.473,3.473,0,0,0-3.488-3.436H6.467a3.474,3.474,0,0,0-3.488,3.436v1.737a12.023,12.023,0,0,0,4.73,1.11,11.492,11.492,0,0,0,4.73-1.11",
    style: {
      fill: "#0cba00"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxInPerson);
export default __webpack_public_path__ + "static/media/bxInPerson.504f58f27694ea5f2201abb160fe6ac4.svg";
export { ForwardRef as ReactComponent };